import { DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { CategorySummaryDTO, PageableFilter } from 'src/app/admin-api';
import { TableColumn } from '../table';
import { TableUtil } from '../table/table.util';

@Component({
  selector: 'app-categories-tree-table',
  templateUrl: './categories-tree-table.component.html',
  styleUrl: './categories-tree-table.component.scss'
})
export class CategoriesTreeTableComponent implements OnInit {
  @Input()
  categories: CategorySummaryDTO[];

  @Input()
  addButton = true;

  private datePipe = inject(DatePipe);

  cols: Array<TableColumn> = [
    new TableColumn(
      'Id',
      'categoryId',
      true,
      'number',
      '/products/categories/',
      'categoryId'
    ),
    new TableColumn(
      'Id Externo',
      'externalIdString',
      true,
      'text',
      '/products/categories/',
      'categoryId',
      true,
      'contains'
    ),
    new TableColumn(
      'Categoria',
      'category',
      true,
      'text',
      '/products/categories/',
      'categoryId',
      true,
      'contains'
    ),
    new TableColumn(
      'Subcategorias',
      'subcategories',
      false,
      'formattedInteger'
    ),
    new TableColumn('Produtos', 'products', false, 'formattedInteger')
  ];
  searchForm: FormGroup | undefined;
  nodes: Array<TreeNode>;

  ngOnInit(): void {
    this.nodes = this.categories.map((c) => TableUtil.categoryToNode(c));
  }

  timeDiffLabel(dateStart: string | Date): string {
    return TableUtil.timeDiffLabel(dateStart, this.datePipe);
  }

  timeLabel(dateStart: string | Date): string | null {
    return TableUtil.timeLabel(dateStart, this.datePipe);
  }

  isRouterLinkAndValid(col: TableColumn, obj: any): boolean {
    return TableUtil.isRouterLinkAndValid(col, obj);
  }

  routerLink(col: TableColumn, obj: any): string {
    return TableUtil.routerLink(col, obj);
  }

  fullLink(col: TableColumn, obj: any): string {
    return TableUtil.fullLink(col, obj);
  }

  valueFromFilter(filter: PageableFilter): any | any[] {
    return TableUtil.valueFromFilter(filter);
  }

  objValue(col: TableColumn, obj: any, field?: string): any {
    return TableUtil.objValue(col, obj, field);
  }

  objDisplay(col: TableColumn, obj: any): any {
    return TableUtil.objDisplay(col, obj);
  }

  externalLink(link: string) {
    return TableUtil.externalLink(link);
  }
}
